import { auth } from './firebase'; // Importar auth desde firebase
import { signInAnonymously, signOut } from 'firebase/auth';

const TOKEN_KEY = 'admin_token';
const ADMIN_PASSWORD = 'FlautaDulce26Ñ4%'; // This must match the server's ADMIN_SECRET_TOKEN

export const login = async (password) => {
  if (password === ADMIN_PASSWORD) {
    try {
      // Iniciar sesión anónimamente con Firebase
      await signInAnonymously(auth);
      sessionStorage.setItem(TOKEN_KEY, ADMIN_PASSWORD);
      return true;
    } catch (error) {
      console.error("Firebase anonymous sign-in failed", error);
      return false;
    }
  }
  return false;
};

export const logout = async () => {
  try {
    // Cerrar la sesión de Firebase
    await signOut(auth);
    sessionStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    console.error("Firebase sign-out failed", error);
    // Aún así, eliminamos el token local
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

export const isAuthenticated = () => {
  return sessionStorage.getItem(TOKEN_KEY) !== null;
};

export const getAuthToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};
